export enum FootnoteItem {
  RELEVANCY = "relevancy",
  DOCUMENTS = "documents",
}
